import { PremiumItem } from "../chit";
import { files as botEmojiFiles } from "./bots";
import { files as popularEmojiFiles } from "./popular";
export const emojiGroupNames = {
    0: "OC Bots",
    1: "Popular",
};
function filenameToEmoji(dir, filename, premiumItem) {
    const [code] = filename.split(".");
    return {
        kind: "custom",
        code: `${dir}_${code}`,
        premiumItem,
        filename,
        url: `/assets/emoji/${dir}/${filename}`,
    };
}
const botEmojis = [...botEmojiFiles].map((e) => filenameToEmoji("bots", e, PremiumItem.BotEmojis));
const popularEmojis = [...popularEmojiFiles].map((e) => filenameToEmoji("popular", e, PremiumItem.PopularEmojis));
export const customEmojis = new Map([...botEmojis, ...popularEmojis].map((e) => [e.code, e]));
